import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { ParametrosComponent } from "./parametros/parametros.component"; 
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { ParametrosRoutingModule } from "./parametros.routing.module";

@NgModule({
    declarations: [
        ParametrosComponent
    ],
    imports: [
        CommonModule , 
        FormsModule , 
        ReactiveFormsModule , 
        SharedModule, 
        ParametrosRoutingModule , 
        NgbAccordionModule
    ]
})
export class ParametrosModule {}